import {
  CREATE_EQUIPMET_ORDER_DONE,
  CREATE_EQUIPMET_RETURN_TO_SHOP_DONE,
  DELETE_EQUIPMENT_ORDER_DONE,
  FETCH_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE,
  RETURN_EQUIPMENT_ORDERS_TO_SHOP,
  RE_ASSIGN_ITEM_TO_JOB_DONE,
  SET_EQUIPMEMNT_JOB,
  SET_SELECTED_JOB_EQUIPMENTS,
  UPDATE_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE,
  UPDATE_CURRENT_JOB_EQUIPMENT,
  UPDATE_EQUIPMENT_RECORD_CONTACTS,
  UPDATE_EQUIPMENT_RECORD_RETURN_TO_SHOP_DONE,
  UPDATE_EQUIPMET_ORDER_DONE,
  UPDATE_RETURNED_EQUIPMENTS,
  UPDATE_RETURNS,
  UPDATE_EQUIPMENTS_FILTERED,
  PRINT_DATA_VISUALIZATION,
} from "../actions";

const equipmentsReducer = (
  state = {
    // initial state
    currentJobEquipments: [],
    filteredEquipments: [],
    returnedEquipments: [],
    selectedJobEquipments: [],
    returns: [],
    savedHiddenColumns: [],
    equipmentJobId: null,
    createEquipmentOrderDone: false,
    updateEquipmentOrderDone: false,
    updateReturnedEquipmentsDone: false,
    updateEquipmentRecordContactsDone: false,
    createEquipmentReturnToShopDone: false,
    reAssignItemToJobDone: false,
    updateEquipmentRecordReturnToShopDone: false,
    deleteEquipmentOrderDone: false,
    returnEquipmentOrdersToShopDone: false,
    returnReturnsDone: false,
    updateAllJobsEquipmentHidableColumnsDone: false,
    isOpenPrintDataVisualization: false,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_CURRENT_JOB_EQUIPMENT:
      return {
        ...state,
        currentJobEquipments: action.currentJobEquipments.reverse(),
        createEquipmentOrderDone: false,
        updateEquipmentOrderDone: false,
        updateReturnedEquipmentsDone: false,
        updateEquipmentRecordContactsDone: false,
        createEquipmentReturnToShopDone: false,
        deleteEquipmentOrderDone: false,
        returnEquipmentOrdersToShopDone: false,
        updateAllJobsEquipmentHidableColumnsDone: false,
      };
    case SET_EQUIPMEMNT_JOB:
      return {
        ...state,
        equipmentJob: action.equipmentJob,
      };
    case CREATE_EQUIPMET_ORDER_DONE:
      return {
        ...state,
        createEquipmentOrderDone: true,
      };
    case CREATE_EQUIPMET_RETURN_TO_SHOP_DONE:
      return {
        ...state,
        createEquipmentReturnToShopDone: true,
      };
    case UPDATE_EQUIPMET_ORDER_DONE:
      return {
        ...state,
        updateEquipmentOrderDone: true,
      };
    case SET_SELECTED_JOB_EQUIPMENTS:
      return {
        ...state,
        selectedJobEquipments: [...action.selectedJobEquipments],
        createEquipmentOrderDone: false,
        updateEquipmentOrderDone: false,
        updateEquipmentRecordContactsDone: false,
        returnEquipmentOrdersToShopDone: false,
        updateAllJobsEquipmentHidableColumnsDone: false,
      };
    case UPDATE_RETURNED_EQUIPMENTS:
      return {
        ...state,
        returnedEquipments: [...action.returnedEquipments],
        updateReturnedEquipmentsDone: false,
        createEquipmentReturnToShopDone: false,
        reAssignItemToJobDone: false,
        updateEquipmentRecordReturnToShopDone: false,
        returnEquipmentOrdersToShopDone: false,
        updateAllJobsEquipmentHidableColumnsDone: false,
      };
    case UPDATE_RETURNS:
      return {
        ...state,
        returns: [...action.returns],
      };
    case UPDATE_EQUIPMENTS_FILTERED:
      return {
        ...state,
        filteredEquipments: [...action.filteredEquipments],
      };
    case UPDATE_EQUIPMENT_RECORD_CONTACTS:
      return {
        ...state,
        updateEquipmentRecordContactsDone: true,
      };
    case RE_ASSIGN_ITEM_TO_JOB_DONE:
      return {
        ...state,
        reAssignItemToJobDone: true,
      };
    case UPDATE_EQUIPMENT_RECORD_RETURN_TO_SHOP_DONE:
      return {
        ...state,
        updateEquipmentRecordReturnToShopDone: true,
      };
    case DELETE_EQUIPMENT_ORDER_DONE:
      return {
        ...state,
        deleteEquipmentOrderDone: true,
      };
    case RETURN_EQUIPMENT_ORDERS_TO_SHOP:
      return {
        ...state,
        returnEquipmentOrdersToShopDone: true,
      };
    case FETCH_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE:
      return {
        ...state,
        savedHiddenColumns: [...action.savedHiddenColumns],
        updateAllJobsEquipmentHidableColumnsDone: false,
      };
    case UPDATE_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE:
      return {
        ...state,
        updateAllJobsEquipmentHidableColumnsDone: true,
      };
    case PRINT_DATA_VISUALIZATION:
      return {
        ...state,
        isOpenPrintDataVisualization: action.isOpen,
      };

    default:
      return state;
  }
};

export default equipmentsReducer;
